
<template>
    <!-- 便民查询表 -->
    <div class="buttonlist">
        <el-form
          :inline="true"
          :model="filteForm"
          class="demo-form-inline toolbar"
          style="padding-bottom: 0px"
          @submit.native.prevent>
          <el-form-item label="项目名称">
            <el-input v-model.trim="filteForm.name" auto-complete="off" maxlength="25" class="width80"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              icon="el-icon-search"
              plain
              @click="onSubmit">查询</el-button> 
            <el-button type="warning" icon="el-icon-plus" @click="addPj" plain>新增</el-button>
            <el-button type="success" icon="el-icon-notebook-2" @click="showRecord" plain>查询记录</el-button>
          </el-form-item>
        </el-form>
        <div v-loading="loading" element-loading-text="拼命加载中......">
          <el-table
            :data="tableData"
            style="width: 100%"
            :row-style="tableRowStyle"
            :header-cell-style="tableHeaderColor">
            <el-table-column prop="name" label="标题" align=center></el-table-column>
            <el-table-column prop="content" :show-overflow-tooltip="true" label="内容" align=center></el-table-column>
            <el-table-column prop="url" label="链接"  :show-overflow-tooltip="true" align=center></el-table-column>
            <el-table-column prop="creator" label="创建人" align=center></el-table-column>
            <el-table-column prop="createdTime" :width="150" label="创建时间" align=center></el-table-column>
            <el-table-column
                prop="option"
                label="操作"
                align="center"
                width="150">
                <template slot-scope="scope">
                   <el-button
                    type="primary"
                    size="mini"
                    plain
                    @click="editPj(scope.row)"
                    >编辑</el-button>
                  <el-button
                   type="warning"
                   size="mini"
                   plain
                   @click="showDetail(scope.row)"
                   >查询</el-button>
                </template>
            </el-table-column>
          </el-table>
          <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            layout="total, prev, pager, next"
            :total="totalDataNumber"
            :page-size="pageSize"
            align="center"
            class="fenye"
          ></el-pagination>
        </div>

        <el-dialog  :title="addForm.id==null ? '新增查询项目' : '修改查询项目'" width="60%" 
        :visible.sync="pjShow">
        <el-form :model="addForm" label-width="120px"  label-position="right">
          <el-form-item label="标题" prop="name">
            <el-input v-model.trim="addForm.name" auto-complete="off" placeholder="" style="width:80%;"></el-input>
          </el-form-item>
          <el-form-item label="链接" prop="url">
            <el-input v-model.trim="addForm.url" auto-complete="off" placeholder="" style="width:80%;"></el-input>
          </el-form-item>
          <el-form-item label="内容" prop="content">
            <el-input v-model.trim="addForm.content" auto-complete="off" 
            placeholder="问题描述.500字以内"
            type="textarea"
            :rows="5"
            show-word-limit
            maxlength="500"
            style="width:80%;"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click.native="pjShow = false">取消</el-button>
          <el-button type="primary" @click.native="submitAddForm">确定</el-button>
        </div>
      </el-dialog>
    </div>
  </template>
  <script>
  import bus from "@/vuex/eventBus"; //引入eventBus,接收子界面传递的跳转指令,然后在父界面跳转,添加tab
  export default {
    data() {
      return {
        pageNum: 1, //页码
        pageSize: 10, //每页显示的条数
        totalDataNumber:0,
        loading:true,
        addForm:{

        },
        pjShow:false,
        dayStr:"",
        filteForm: {
          type: "",
          name:""
        },
        tableData:[],
        typeList:[],
      };
    },
    methods: {
      showRecord(){
        bus.$emit("homePage", {
            type: "jump",
            path: "/ConvenientSearchRecord",
            title: '便民查询记录'
        });
      },
      showDetail(row){
        let params = {
          name:row.name
        }
        this.$postJson('omc/convenientSearch/addRecord',params);
        window.open(row.url);
      },
      addPj(){
        this.pjShow = true;
        this.addForm = {
          name:"",
          url:"",
          content:""
        }
      },
      editPj(item){
        this.pjShow = true;
        this.addForm = Object.assign({}, item);
      },
      submitAddForm(){
        let url = 'omc/convenientSearch/addPj';
        if(this.addForm.id != null){
          url = 'omc/convenientSearch/updatePj';
        }
        let params = Object.assign({}, this.addForm);
        this.$postJson(url,params).then(res=>{
          if(res.code==200){
            this.pjShow = false;
            this.onSubmit();
          }else {
              this.$message({
                message: "操作失败, " + res.message,
                type: "error",
              });
          }
        })
      },
      //点击查询
      onSubmit() {
        this.pageNum = 1;
        this.getTableData();
      },
      tableRowStyle({ row, rowIndex }) {
        if (rowIndex % 2 == 0) {
          return "background-color: #ffffff";
        } else {
          return "background-color: #e4f5f8";
        }
      },
      tableHeaderColor({ row, column, rowIndex, columnIndex }) {
        if (rowIndex === 0) {
          return "color:#2d2d2d;font-weight: 600; text-align: center;font-size: 16px;background-color: #d4f5fa;";
        }
      },
      //获取分页的紧急按钮数据  只获取pageSize条数据
      getTableData() {
        let params = {
          groupId:this.groupId,
          pageSize:this.pageSize,
          name: this.filteForm.name|| undefined,
          pageNum:this.pageNum
        };
        this.loading = true;
        this.$postJson('omc/convenientSearch/showPjList',params).then(res=>{
          if(res.code==200){
            this.totalDataNumber = Number(res.result.total)
            this.tableData = res.result.list;
          }
          this.loading = false;
        })
      },
      handleCurrentChange(val) {
        this.pageNum = val;
        this.getTableData();
      },
      
    },
    mounted() {
      this.getTableData();
    },
    created(){
      this.groupId = sessionStorage.getItem("groupId");
    },
  };
  </script>
  <style lang="scss" scoped>
  .buttonlist {
      padding: 10px 0 0 5px;
  }
  .fenye {
    margin: 0;
    padding: 30px 0;
    background: #fff;
  }
  </style>